import React, { forwardRef } from "react";
import { classNames } from "../utils/classNames";
import { useViewStyles } from "./View.styles";
export const View = forwardRef((props, contentRef) => {
    let Element = props?.elementType ?? "div";
    return (React.createElement(Element, { className: classNames(useViewStyles(props).view), ref: contentRef, role: props?.role }, props?.children));
});
